/**
 * Shared sidebar / app-shell nav palette — dark chrome used by module
 * sidebars (inventory today; any future module with the same nav pattern).
 */
import { IPD_COLORS } from "./ipdColors";

export const IPD_SIDEBAR = {
  bg: IPD_COLORS.primaryDark,
  bgGradientEnd: IPD_COLORS.sidebar.bgGradientEnd,
  hover: IPD_COLORS.primary,
  active: IPD_COLORS.primaryLight,
  text: IPD_COLORS.sidebar.text,
  label: IPD_COLORS.sidebar.label,
  border: IPD_COLORS.sidebar.border,
};
